import ArcProgressBar from './ArcProgressBar'

export default ArcProgressBar
